import React, { useEffect, useState } from 'react';
import { IonButton } from '@ionic/react';

const SW_UPDATE_KEY = 'sc_sw_update_pending';

const NewVersionCheck: React.FC = () => {
  const [visible, setVisible] = useState(() => localStorage.getItem(SW_UPDATE_KEY) === '1');
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | undefined>(
    undefined
  );
  const [actionMessage, setActionMessage] = useState<string | null>(
    localStorage.getItem(SW_UPDATE_KEY) === '1' ? 'Update available' : null
  );

  useEffect(() => {
    function onSWUpdated(e: Event) {
      const ce = e as CustomEvent<any>;
      const detail = ce?.detail;
      const reg: ServiceWorkerRegistration | undefined =
        detail?.registration ?? detail ?? undefined;
      setRegistration(reg);
      setActionMessage('Update available');
      localStorage.setItem(SW_UPDATE_KEY, '1');
      setVisible(true);
    }

    window.addEventListener('swUpdated', onSWUpdated as EventListener);
    return () => window.removeEventListener('swUpdated', onSWUpdated as EventListener);
  }, []);

  const handleRestart = () => {
    void onRestart();
  };

  const onRestart = async () => {
    try {
      setActionMessage('New Version updating now');
      localStorage.removeItem(SW_UPDATE_KEY);
      const reg = registration ?? (await navigator.serviceWorker.getRegistration());
      if (reg?.waiting) {
        // Post SKIP_WAITING and let the controllerchange listener in index.tsx
        // handle the reload. DO NOT call reload() here — the controllerchange
        // event fires almost instantly, and a second reload (setTimeout or
        // immediate) races with it, causing mid-flight chunk requests to abort
        // with ERR_ABORTED 404. The server then returns index.html for those
        // missing URLs, which the browser rejects with a MIME-type error, and
        // Ionic's router throws "Cannot read properties of undefined (reading
        // 'payload')" because history.state is torn mid-navigation.
        reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        return;
      }

      // No waiting worker — just reload directly. This is safe because there's
      // no controllerchange event pending; we're the only reload trigger.
      window.location.reload();
    } catch (err) {
      setActionMessage('Error applying update');
    }
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 12,
        right: 12,
        bottom: 20,
        zIndex: 9999,
        background: '#323232',
        color: '#fff',
        padding: '12px 16px',
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
      }}
    >
      <div style={{ marginRight: 12 }}>
        <div>Update available – Refresh App</div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <IonButton
          onClick={(e) => {
            e.preventDefault();
            handleRestart();
          }}
          style={{
            color: '#fff',
            border: 'none',
            padding: '8px 12px',
            borderRadius: 6,
          }}
        >
          Refresh
        </IonButton>
      </div>
    </div>
  );
};

export default NewVersionCheck;
